/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

import { Component, Input, OnInit } from "@angular/core";
import { MerchantDetailsParentComponent } from "../merchant-details-parent.component";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService, MerchantService, NotificationService, MerchantUserService } from "../../../services";
import { MerchantUserRoles, EditType, Merchant } from "../../../models";
import { BsModalRef, BsModalService, ModalOptions } from "ngx-bootstrap/modal";
import { AddEditUserComponent } from "./add-edit-user/add-edit-user.component";

@Component({
  selector: "app-users-and-roles",
  templateUrl: "./users-and-roles.component.html"
})
export class UsersAndRolesComponent extends MerchantDetailsParentComponent implements OnInit {
  @Input("merchant") merchant!: Merchant;
  userEditType = EditType;
  modalRef?: BsModalRef;
  merchantUsersRoles!: MerchantUserRoles[];

  constructor(
    router: Router,
    activatedRoute: ActivatedRoute,
    merchantService: MerchantService,
    notificationService: NotificationService,
    authService: AuthService,
    private merchantUserService: MerchantUserService,
    private modalService: BsModalService
  ) {
    super(router, activatedRoute, merchantService, notificationService, authService);
  }

  ngOnInit(): void {
    this.merchantUserService.getUsersAndRoles(this.merchant.id).subscribe(
      (usersRoles) => (this.merchantUsersRoles = usersRoles),
      (error) => this.notificationService.error(error.error)
    );
  }

  openModal(type: EditType, title: string, user?: MerchantUserRoles, index?: number) {
    const initialState: ModalOptions = {
      initialState: {
        action: type,
        title: title,
        merchantUser: user,
        merchantId: this.merchant.id
      }
    };
    this.modalRef = this.modalService.show(AddEditUserComponent, initialState);

    this.modalRef.content.event.subscribe((merchantUser: MerchantUserRoles) => {
      switch (type) {
        case EditType.remove:
          if (typeof index === "number") {
            this.merchantUsersRoles.splice(index, 1);
          }
          break;
        case EditType.edit:
          if (typeof index === "number") {
            this.merchantUsersRoles[index] = merchantUser;
          }
          break;
        case EditType.add:
          this.merchantUsersRoles.push(merchantUser);
          break;
      }
    });
  }
}
